import { FallbackError } from "@core/domain/errors/fallback.error";
import { LanguageIsoCodeEnum } from "@core/domain/models/language.model";
import type { SelectOption } from "@core/domain/types/select-option";
import i18n, { changeLanguage } from "i18next";
import { injectable } from "inversify";
import { Settings } from "luxon";
import type { Result } from "neverthrow";
import { err, ok, ResultAsync } from "neverthrow";

@injectable()
export class LanguageLocalDatasource {
    /** Not narrowed: it may carry a region (`es-ES`). */
    getCurrent(): Result<string, FallbackError> {
        if (!i18n.isInitialized) return err(new FallbackError());

        return ok(i18n.language);
    }

    getDefault(): Result<string, FallbackError> {
        if (!i18n.isInitialized) return err(new FallbackError());

        const [defaultLanguage] = [i18n.options.fallbackLng].flat();

        return typeof defaultLanguage === "string"
            ? ok(defaultLanguage)
            : err(new FallbackError());
    }

    update(language: LanguageIsoCodeEnum): ResultAsync<true, FallbackError> {
        return ResultAsync.fromPromise(
            changeLanguage(language),
            () => new FallbackError(),
        ).map(() => {
            Settings.defaultLocale = i18n.language;
            return true;
        });
    }

    getAll(): SelectOption<LanguageIsoCodeEnum>[] {
        return [
            {
                value: LanguageIsoCodeEnum.English,
                label: LanguageIsoCodeEnum.English,
            },
            {
                value: LanguageIsoCodeEnum.Spanish,
                label: LanguageIsoCodeEnum.Spanish,
            },
            {
                value: LanguageIsoCodeEnum.French,
                label: LanguageIsoCodeEnum.French,
            },
        ];
    }
}
